import Vue from 'vue'
import { Area, Rate, Checkbox, CheckboxGroup, Collapse, CollapseItem, Loading, Image, Tag, Notify, Uploader, Field, Form, Swipe, SwipeItem, Sidebar, SidebarItem, Tab, Tabs, NoticeBar, Popup, Toast, DropdownMenu, DropdownItem, Grid, GridItem, NavBar, IndexBar, IndexAnchor, PullRefresh, Icon, Cell, CellGroup, List, Search, Button, Tabbar, TabbarItem } from 'vant'

Vue.use(Search)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Button)
Vue.use(List)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Icon)
Vue.use(PullRefresh)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(NavBar)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Toast)
Vue.use(Popup)
Vue.use(NoticeBar)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Field)
Vue.use(Form)
Vue.use(Uploader)
Vue.use(Notify)
Vue.use(Tag)
Vue.use(Image)
Vue.use(Loading)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Rate)
Vue.use(Area)
